import React, { Component } from 'react'

import Loader from './utils/Loader'

class GeneralLoader extends Component {
    render(){
        return (
            <div className="pt2 pb2">
                <Loader />
            </div>
        )
    }
}

export default GeneralLoader



// WEBPACK FOOTER //
// ./src/components/GeneralLoader.js